export default __webpack_public_path__ + "static/media/Winteler.d4c8e7de.jpg";